import React, {useContext} from 'react';
import {Accordion, Table} from "react-bootstrap";
import AccordionContext from 'react-bootstrap/AccordionContext';
import {useWatch} from "react-hook-form";
import ChangeFieldList from "./ChangeFieldList";
import AcceptReject from "./AcceptReject";
import StatusBadge from "./StatusBadge";
import EnhancedAccordionBody from "../../../components/common/EnhancedAccordionBody";

const ChangeAccordionItem = ({
                                 index, controlId, properties, header, effectiveDate, hiddenPropertyNames = [],
                                 displayOnlyPropertyNames = [], ...props
                             }) => {
    const status = useWatch({name: `${controlId}.status`});
    const { activeEventKey } = useContext(AccordionContext);
    return (
        <Accordion.Item eventKey={index.toString()}>
            <Accordion.Header>
                Change: {header} as of {effectiveDate}
                <StatusBadge status={status} />
            </Accordion.Header>
            <EnhancedAccordionBody createChildren={"whenExpanded"}>
                {props.children}
                <Table size={"sm"} striped className={"fs--1 mb-0"}>
                    <thead className="bg-200 text-900 text-nowrap align-middle">
                    <tr>
                        <th scope={"col"}>Property Name</th>
                        <th scope={"col"}>Original Value</th>
                        <th scope={"col"}>New Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ChangeFieldList index={index} controlId={controlId} properties={properties} status={status}
                                     hiddenPropertyNames={hiddenPropertyNames}
                                     displayOnlyPropertyNames={displayOnlyPropertyNames}
                                     activeEventKey={activeEventKey}
                        />
                    </tbody>
                </Table>
                <AcceptReject controlId={controlId} />
            </EnhancedAccordionBody>
        </Accordion.Item>
    )
}
ChangeAccordionItem.defaultProps = {}
ChangeAccordionItem.propTypes = {}
export default ChangeAccordionItem